"use strict";

function greaterThan(oldValue, newValue, _ref) {
  var quantity = _ref.quantity,
      component = _ref.component,
      opts = _ref.opts;
  var _opts$condition = opts.condition,
      key = _opts$condition.key,
      value = _opts$condition.value;
  var val;

  if (key === 'quantity') {
    val = quantity;
  } else {
    val = component[key];
  }

  if (parseFloat(val, 10) > parseFloat(value, 10)) {
    return newValue;
  }

  return oldValue;
}

module.exports = greaterThan;